export function flattenAbcForPlayback(abc) {
  const lines = abc.split('\n');
  const header = [];
  const rawBodyLines = [];
  let inBody = false;

  // Separate header and raw body
  for (const line of lines) {
    if (!inBody && /^[A-Z]:/.test(line)) {
      header.push(line);
    } else {
      inBody = true;
      rawBodyLines.push(line);
    }
  }

  // ✅ Split multi-section lines at :| boundaries
  const bodyLines = [];
  for (const line of rawBodyLines) {
    if (!line.trim() || /^[A-Z]:/.test(line)) {
      bodyLines.push(line);
    } else {
      const parts = line.split(':|');
      for (let i = 0; i < parts.length; i++) {
        const part = parts[i].trim();
        if (part) {
          bodyLines.push(part + (i < parts.length - 1 ? ':|' : ''));
        }
      }
    }
  }

  // ✅ Merge and normalize
  let body = bodyLines.join(' ')
    .replace(/%.*$/gm, '')     // Remove comments
    .replace(/\s+/g, ' ')      // Normalize whitespace
    .trim();

  // ✅ Strip grace notes
  body = body.replace(/{[^}]+}/g, '');

  // ✅ Force bars onto separate lines at every '|'
body = body.replace(/\|/g, '|\n');
// body = body.replace(/\(3(\w)(\w)(\w)/g, '$1 $3');


  const segments = [];
  let i = 0;

  while (i < body.length) {
    const startIdx = body.indexOf('|:', i);
    if (startIdx === -1) {
      segments.push(body.slice(i));
      break;
    }

    const endIdx = body.indexOf(':|', startIdx);
    if (endIdx === -1) {
      segments.push(body.slice(i));
      break;
    }

    if (i < startIdx) {
      segments.push(body.slice(i, startIdx));
    }

    const repeatBlock = body.slice(startIdx + 2, endIdx);

    const match = repeatBlock.match(/\[1(.*?)\[2(.*)/);
    if (match) {
      const before = repeatBlock.slice(0, match.index).trim();
      const firstEnding = match[1].trim();
      const secondEnding = match[2].trim();

      const expanded = [
        before, firstEnding,
        before, secondEnding
      ].join(' ');
      segments.push(expanded);
    } else {
      segments.push(repeatBlock.trim(), repeatBlock.trim());
    }

    i = endIdx + 2;
  }

  const flatBody = segments.join(' ').replace(/\[1|\[2/g, '').trim();
  return header.join('\n') + '\n' + flatBody;
}
